import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Whatmob() {
  return (
    <section className="what_mob p-100 text_milo">
      <Container>
        <Row>
          <Col
            xs={12}
            md={10}
            lg={10}
            xl={10}
            xxl={10}
            className="m-auto text-center"
          >
            <h2>
              <span>Conclusion</span> 
            </h2>
            <p>
              TekRevol's MiloCare+ has successfully translated an unrealistic
              idea into a strong and user-friendly mobile app. By conquering
              considerable challenges and providing state-of-the-art solutions,
              it influences users to proficiently handle their health records,
              specifically those linked to Covid. With its untiring pledge to
              data security and user ease, MiloCare+ stands as a reliable
              solution for individuals, their families and loved ones,
              redefining the ecosystem of healthcare and its record management.
            </p>
            <div className="what_mob_img_milo">
              <StaticImage
                src="../../../images/case-studies/milocare/conclusion.webp"
                alt="TekRevol"
                layout="constrained"
                placeholder="blurred"
                formats={["webp"]}
                width={1172}
                height={608}
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Whatmob;
